
// => Styling
import styles from './StatusBar.module.css';

// => Svgs
import brand from '../content/brand_1.svg';
import brand_new from '../content/brand_new.svg';
import { ReactComponent as Dick} from '../content/dick.svg';
import { ReactComponent as Male} from '../content/male.svg';

// => Icons
import { GiVibratingShield } from "react-icons/gi";
import { IoDiamond } from "react-icons/io5";

// => Components
import StatusIcon from './StatusIcon';
import Thermometer from './Thermometer';
import Indicator from './Indicator';

// => React
import { useEffect, useRef } from 'react';


// ============
// Component
// ============
const StatusBar = ({
    showGame = true,
    cockChance = 0,
    masculinity = 0,
    safeTimer = null,
    currency = 0,
}) => {

    const initalized = useRef(false)


    const getCockProbabilityText = () => {
        if (cockChance >= 80) {
            return "HOT!!!"
        } else if (cockChance >= 60) {
            return "High"
        } else if (cockChance >= 40) {
            return "Medium"
        } else {
            return "Low"
        }
    }
    const getCockProbabilityColor = () => {
        if (cockChance >= 80) {
            return "red"
        } else if (cockChance >= 60) {
            return "orange"
        } else if (cockChance >= 40) {
            return "yellow"
        } else {
            return "green"
        }
    }

    useEffect(() => {
        if (!initalized.current) {
            initalized.current = true
            return
        }
    }, [currency])


    // RENDER
    // ---------
    return(
        <div className={styles.container}>

            <div className={styles.brand}>
                <img className={styles.brandImg}
                    src={brand_new}
                    alt='Cock Roulette' />
                    <span className={styles.versionLabel}>0.4.1</span>
            </div>
            
            <div className={styles.persistentValues}>
                <div className={styles.currency}>
                    <span className={styles.currencyIcon}><IoDiamond /></span>
                    {currency}
                </div>
            </div>
            
            {showGame && (<div className={styles.gameStatus}>
                
                {/* Placeholder */}
                {/*<StatusIcon>
                    <Thermometer current={33} size="28px" />
                </StatusIcon>
                <StatusIcon>
                    <Thermometer current={33} size="28px" />
            </StatusIcon>*/}

                
                {/* Safe timer indicator */}
                <StatusIcon id="safe-timer-indicator"
                            tooltip={safeTimer && <span className={styles.tooltipText}>Temporary Cock <span className={styles.tooltipTextHighlight}>PROTECTION</span></span>}>
                    <Indicator  icon={<GiVibratingShield />}
                                size="28px"
                                value={safeTimer} />
                </StatusIcon>


                {/* Cock chance thermometer */}
                <StatusIcon id="cock-chance-thermometer"
                            tooltip={<span className={styles.tooltipText}>Danger: <span className={styles.tooltipTextHighlight} style={{color: getCockProbabilityColor()}}>{getCockProbabilityText()}</span></span>}>
                    <Thermometer current={cockChance}
                        min={0}
                        max={100}
                        colorCold = "#c4c4c4"
                        colorHot = "#ff317c"
                        size = "28px" />
                </StatusIcon>


                {/* Masculinity */}
                <StatusIcon id="masculinity-thermometer"
                            tooltip={<span className={styles.tooltipText}>Masculinity: <span className={styles.tooltipTextHighlight}>{masculinity}%</span></span>}>
                    <Thermometer current={masculinity}
                                min={0}
                                max={100}
                                colorCold='#c4c4c4'
                                colorHot='#c4c4c4'
                                size='28px'
                                icon={<Male className={styles.dick} />}
                                alertIcon={null}
                                showValue={true}
                                iconRotated={false} />
                </StatusIcon>


            </div>)}

        </div>
    )
}


export default StatusBar